import type { ButtonHTMLAttributes, ReactNode } from 'react'
import s from './Button.module.scss'

export type ButtonVariant = 'primary' | 'plain' | 'quiet' | 'danger'

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant
  /** Über die ganze verfügbare Breite — auf Anmeldeformularen der Regelfall. */
  block?: boolean
  children: ReactNode
}

export function Button({ variant = 'plain', block, children, ...rest }: Props) {
  return (
    <button
      {...rest}
      // `type` ausdrücklich: Ein Knopf ohne Angabe ist in einem Formular ein
      // Absende-Knopf und schickt es beim Klicken ab, auch wenn er etwas
      // anderes tun soll.
      type={rest.type ?? 'button'}
      className={`${s.button} ${s[variant]} ${block ? s.block : ''}`}
    >
      {children}
    </button>
  )
}
